import { render, staticRenderFns } from "./WorkTextEditorImageUploadArea.vue?vue&type=template&id=6dadbe19&scoped=true"
import script from "./WorkTextEditorImageUploadArea.vue?vue&type=script&lang=js"
export * from "./WorkTextEditorImageUploadArea.vue?vue&type=script&lang=js"
import style0 from "./WorkTextEditorImageUploadArea.vue?vue&type=style&index=0&id=6dadbe19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dadbe19",
  null
  
)

export default component.exports